import Uri from 'jsuri';
import md5 from 'md5';
import util from './util';
import extend from 'node.extend';

/**
 * @param {import('jsUri')} uri
 * @returns
 */
export function getEntryRelativeItemMark(uri) {
    const inside = uri.getQueryParamValue('insidesource') || window.sessionStorage.getItem('inside') || '';
    const outside = uri.getQueryParamValue('outsidesource') || window.sessionStorage.getItem('outside') || '';
    const fm = uri.getQueryParamValue('fm') || window.sessionStorage.getItem('fm') || '';
    const channel = uri.getQueryParamValue('channel') || window.sessionStorage.getItem('channel') || '';
    return {
        inside,
        outside,
        fm,
        channel
    };
}

/**
 * @param {import('jsUri')} uri
 * @returns
 */
export function setEntryRelativeItemMark(path) {
    const uri = new Uri(path || window.location.href);
    const inside = uri.getQueryParamValue('insidesource') || '';
    const outside = uri.getQueryParamValue('outsidesource') || '';
    const fm = uri.getQueryParamValue('fm') || '';
    const channel = uri.getQueryParamValue('channel') || '';
    window.sessionStorage.setItem('inside', inside);
    window.sessionStorage.setItem('outside', outside);
    window.sessionStorage.setItem('fm', fm);
    window.sessionStorage.setItem('channel', channel);
}

function getItemMark(userInput, uri = new Uri(window.location.href)) {
    let {fm, channel, inside, outside} = userInput || {};
    const sessionItemMark = getEntryRelativeItemMark(uri);
    if (!fm) {
        fm = sessionItemMark.fm;
    }
    if (!channel) {
        channel = sessionItemMark.channel;
    }
    if (!inside) {
        inside = sessionItemMark.inside;
    }
    if (!outside) {
        outside = sessionItemMark.outside;
    }
    return extend(
        {
            ...getEntryRelativeItemMark(uri)
        },
        userInput,
        {
            fm,
            channel,
            inside,
            outside
        }
    );
}

/**
 *
 * @param {import('../types/bi').BiUser}
 */
function handleUser(_this, reportData) {
    const USER_ENABLE = ['user_mark'];
    if (reportData.user && Object.keys(reportData.user).filter(v => USER_ENABLE.includes(v)).length) {
        _this.data.extend({
            user: {
                user_mark: reportData.user.user_mark
            }
        });
    }
}

function biHandleProperties(_this, item = {}) {
    const uri = new Uri(_this.fromFullPath || window.location.href);
    const propertiesPosition = uri.getQueryParamValue('utm_source') || '__SHARECHANEL__';
    const propertiesTime = new Date().getTime();
    const itemId = item.itemid || '-1';
    const itemType = item.item_type || _this.baseCofig.item_type || '';
    const itemMark = getItemMark(item.item_mark, uri);
    // 生成规则为：把事件属性对象中的itemid，item_type，item_mark，当前时间戳依次连接后MD5成32位字符串，截取第9到16位。
    const ssidString = `${itemId}${itemType}${JSON.stringify(itemMark)}`;

    const propertiesTemp = extend(true, _this.data.baseData.properties, {
        itemid: itemId,
        item_type: itemType,
        item_mark: itemMark,
        position: item.position || propertiesPosition,
        time: propertiesTime,
        sessionid: md5(ssidString).substr(9, 16)
    });

    return JSON.parse(JSON.stringify(propertiesTemp));
}

const PROJECT = {
    BI: {
        reportUrl: '//dmp-api.mama.cn/receive',
        handleUser,
        handleProperties: (_this, reportData) => {
            let propertiesTemp = [];
            if (Array.isArray(reportData.properties)) {
                reportData.properties.forEach(v => {
                    propertiesTemp.push(biHandleProperties(_this, v));
                });
            } else {
                propertiesTemp = biHandleProperties(_this, reportData.properties);
            }
            _this.data.extend({
                properties: propertiesTemp
            });
        },
        handleContent: _this => {
            if (util.isMamaApp && window.MJSSDK) {
                _this.data.extend({
                    content: {
                        app_ver: window.MJSSDK.UA.appVer
                    }
                });
            }
        }
    },
    // 信息流推荐
    flowRecommend: {
        reportUrl: '//mtracker-api.mama.cn/collect',
        handleUser,
        handleProperties: (_this, reportData) => {
            const item = reportData.properties;
            _this.data.extend({
                properties: {
                    item_type: item.item_type || _this.baseCofig.item_type || '',
                    context: item.context || '-1',
                    time: new Date().getTime(),
                    item_mark: getItemMark(item.item_mark || {})
                }
            });
        }
    }
};

export default PROJECT;
